import React, { PropTypes, Component } from 'react'
import R from 'ramda'
import { fromJS } from 'immutable'
import Promise from 'bluebird'
import {
  searchContinents,
  searchCountriesWithProperties
} from '../../sources/SearchSource'
import { slugify, unslugify } from '../../Utils'
import SearchResult from './SearchResult'

import showBackButton from '../../components/showBackButton'

class SearchByCountry extends Component {
  constructor (props) {
    super(props)
    this.state = {
      parent: {},
      countries: [],
      canLoadMore: true,
      isFetching: false
    }
    this.handleClick = this.handleClick.bind(this)
    this.loadMore = this.loadMore.bind(this)
  }

  shouldComponentUpdate (nextProps, nextState) {
    const { countries, canLoadMore, isFetching } = this.state
    if (
      !fromJS(countries).equals(fromJS(nextState.countries)) ||
      canLoadMore !== nextState.canLoadMore ||
      isFetching !== nextState.isFetching
    ) {
      return true
    }
    return false
  }

  componentWillMount () {
    const { params, location } = this.props
    let continentId = location.query.id || this.state.continentId
    this.setState({ isFetching: true }, () => {
      let query = continentId
        ? { id: continentId }
        : { where: { name: params.continent } }

      searchContinents(query)
        .then(response => {
          let continent = response.data[0] || response.data
          return Promise.all([
            continent,
            searchCountriesWithProperties({ id: continent.id })
          ])
            .spread((parent, response) => {
              this.setState({
                parent: continent,
                countries: response.data.results,
                canLoadMore:
                  response.data.results.length < response.data.noElements,
                isFetching: false
              })
            })
            .catch(error => console.log(error))
        })
        .catch(error => console.log(error))
    })
  }

  loadMore () {
    const { countries, parent } = this.state
    this.setState({ isFetching: true }, () => {
      searchCountriesWithProperties({ id: parent.id, skip: countries.length })
        .then(response => {
          let list = R.sortBy(
            R.prop('name'),
            R.union(countries, response.data.results)
          )
          this.setState({
            countries: list,
            canLoadMore: list.length < response.data.noElements,
            isFetching: false
          })
        })
        .catch(error => console.log(error))
    })
  }

  handleClick (el) {
    this.props.router.push(
      '/search/region/' +
        this.props.params.continent +
        '/' +
        slugify(el.name) +
        '?id=' +
        el.id
    )
  }

  render () {
    const { continent } = this.props.params
    const { canLoadMore, isFetching, countries, parent } = this.state
    const title = unslugify(continent)
    const path = {
      continent: unslugify(continent),
      country: null,
      city: null
    }
    return (
      <SearchResult
        type={'country'}
        router={this.props.router}
        path={path}
        handleClick={this.handleClick}
        results={countries}
        title={title}
        parent={parent}
        isFetching={isFetching}
        canLoadMore={canLoadMore}
        loadMore={this.loadMore}
      />
    )
  }
}

SearchByCountry.propTypes = {
  user: PropTypes.object,
  updatePath: PropTypes.func,
  router: PropTypes.object,
  params: PropTypes.object,
  location: PropTypes.object
}

export default showBackButton(SearchByCountry)



// WEBPACK FOOTER //
// ./src/pages/Search/SearchByCountry.js